import React from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { RootReducer } from 'src/redux/rootReducer'
import { TOGGLE_BUY_NOW_FILTER, FETCH_OFFERS } from 'dealer-reducers'
import track from 'src/helpers/track'
import { FETCH_OFFERS as FETCH_OFFERS_PAGINATED } from 'src/redux/paginatedOffersReducer'

const BuyNowToggleSwitch = (): JSX.Element => {
  const currentTab = useSelector((state: RootReducer) => state.offersListReducer.tab)
  const buyNowFilter = useSelector((state: RootReducer) => state.tableToolsReducer.filters[currentTab].buyNowFiler)
  const paginationType = useSelector((state: RootReducer) => state.layoutReducer.paginationType)
  const dispatch = useDispatch()
  const { t } = useTranslation()
  return (
    <div
      className="cursor-pointer"
      onClick={() => {
        dispatch(TOGGLE_BUY_NOW_FILTER({ tab: currentTab }))
        track('dealer_buy_now_toggle')
        if (paginationType === 'infinite') {
          dispatch(FETCH_OFFERS({ tab: currentTab, refetch: true }))
        } else {
          dispatch(FETCH_OFFERS_PAGINATED({ refetch: true }))
        }
      }}>
      <div
        className="px-3 py-1.5 bg-backgrounds-bg-field-component rounded-lg flex justify-start items-center gap-3 overflow-hidden"
        style={{
          boxShadow:
            '0px 2px 4px 0px rgba(0,0,0,0.04), 0px 1px 2px -1px rgba(0,0,0,0.08), 0px 0px 0px 1px rgba(0,0,0,0.08)'
        }}>
        <div className="w-7 h-5 relative flex justify-center items-center">
          <div
            className="w-7 h-4 left-0 bg-blue-500  rounded-[99px] overflow-hidden relative"
            style={{
              backgroundColor: buyNowFilter ? '#3B82F6' : '#D1D5DB',
              boxShadow:
                '0px 2px 4px 0px rgba(0,0,0,0.04), inset 0px 0px 8px 0px rgba(0,0,0,0.02), inset 0px 0px 0px 0.75px rgba(0,0,0,0.06), inset 0px 2px 4px 0px rgba(0,0,0,0.04), inset 0px 1px 1px 0px rgba(0,0,0,0.04)'
            }}>
            <div
              className="w-3 h-3 left-[14px] top-[2px] absolute bg-foregrounds-fg-on-color rounded-[99px] transition-transform duration-200 ease-in-out"
              style={{
                transform: `translateX(${buyNowFilter ? '0px' : '-12px'})`,
                boxShadow:
                  '0px 0px 1px 0px rgba(0,0,0,0.08), 0px 1px 2px 0px rgba(0,0,0,0.12), 0px 3px 3px 0px rgba(0,0,0,0.04), 0px 5px 4px 0px rgba(0,0,0,0.02), 0px 0px 0px 0.5px rgba(0,0,0,0.02), inset 0px 1px 0px 0px rgba(255,255,255,1.00), inset 0px 0px 2px 1px rgba(255,255,255,1.00)'
              }}
            />
          </div>
        </div>
        <div className="flex flex-col justify-start items-start">
          <div className="flex justify-start items-center gap-1">
            <div className="justify-center text-foregrounds-fg-base text-xs font-semibold font-Montserrat leading-tight">
              {t('buy_now')}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default BuyNowToggleSwitch
